exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-product-option .sweet-modal.is-alert{width:780px;max-height:96vh}.modal-product-option .sweet-modal.is-alert .sweet-content{padding:28px 32px 16px 32px}.modal-product-option .content{max-height:calc(95vh - 295px);overflow-y:auto;margin-bottom:28px}.template-modal .sweet-modal.is-alert{width:467px;max-height:90vh}.template-modal .sweet-modal.is-alert .sweet-content{padding:28px 32px 32px 32px}", ""]);

// exports
